/**
 *
 * supergroups - Filters
 *
 */
import { ODataOperators } from 'api/odata/ODataFilter';
import { GetPageFilters } from 'app/components/BasicTable/BasicFilter/GetPageFilters';
import { IFilterSettings } from 'app/components/BasicTable/BasicFilter/IFilterSettings';

import RegionFilter from 'app/components/BasicTable/Filters/RegionFilter';
import {
  URLSearchParamsCI,
  GetPartialEntity,
  GetRawValue,
  GetNumberOrUndefined,
  initExPickerValue,
} from 'app/components/BasicTable/types/FilterParam';
import { initRegionData } from 'app/components/pickers/AutocompletePickers/RegionPicker';
import { translations } from 'locales/translations';
import { ISuperGroupDto } from '../ISuperGroupDto';

export const GetFilters: GetPageFilters<ISuperGroupDto> = (
  t,
  appSettings,
  user,
  settings,
) => search => {
  const params = new URLSearchParamsCI(search);
  var result: IFilterSettings<ISuperGroupDto>[] = [
    {
      fieldName: 'RegionId',
      displayName: t(translations.Region),
      operator: ODataOperators.Equals,
      queryStringSerializer: 'regionid',
      initData: initExPickerValue(initRegionData, undefined, 'base'),
      value: GetPartialEntity(
        GetNumberOrUndefined(GetRawValue(params, 'regionid')),
      ),
      component: RegionFilter,
      urlType: 'base',
    },
  ];
  return result;
};
